import PropTypes from 'prop-types';
import { Button, Snackbar, Typography } from '@mui/material';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';

ScheduleAbroadMeetingComponent.propTypes = {
  hasMeetingScheduled: PropTypes.bool,
  isOpenDialogLead: PropTypes.bool,
  isQualifiedLead: PropTypes.bool,
  studentIdentifier: PropTypes.string,
};

ScheduleAbroadMeetingComponent.defaultProps = {
  hasMeetingScheduled: false,
  isOpenDialogLead: false,
  isQualifiedLead: false,
  studentIdentifier: '',
};

export default function ScheduleAbroadMeetingComponent({
  hasMeetingScheduled,
  isOpenDialogLead,
  isQualifiedLead,
  studentIdentifier,
}) {
  return (
    <Snackbar
      open={isQualifiedLead && !hasMeetingScheduled && !isOpenDialogLead}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Button
        color="success"
        startIcon={<ForumOutlinedIcon sx={{ height: 45, width: 45 }} />}
        href={`/s/${studentIdentifier}`}
        sx={{ width: { xs: '100%', md: 300 } }}
        variant="contained"
        target="_blank"
      >
        <Typography variant="body1" sx={{ overflowWrap: 'break-word' }}>
          <strong>Dúvidas?</strong>&nbsp;fale grátis com um especialista.
        </Typography>
      </Button>
    </Snackbar>
  );
}
